import React, { Component } from "react";
import { Crisp } from "crisp-sdk-web";
// ePg#hHKqM7ezyPs9
import localefr from "moment-locale-fr";
import momentFerieFr from "moment-ferie-fr";

import AuthLayout from "./containers/AuthLayout";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/global.scss";
import "react-tippy/dist/tippy.css";
import "react-contexify/dist/ReactContexify.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    Crisp.configure("f77f2d2c-2d09-49f5-837e-d9430dd90792");
  }

  render() {
    return <AuthLayout />;
  }
}

export default App;
